import React, { useContext, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import {useGetClientTableSchema} from "../../../hooks/useOfListClient";

import { Card, Row } from "react-bootstrap"

import List from '../../../components/Controls/List';
import { ColumnRender_Actions, columnRender_Name } from "./ColumnRender";
import MainAppContext from "../../../MainAppContext";
import AuthVerify from "../../../components/AuthVerify";
import { useSelector } from "react-redux";

export default function ListClients() {
    const { t } = useTranslation();
    const history = useHistory();

    const contextSite = useContext(MainAppContext);
    const { user: currentAuth } = useSelector((state) => state.auth);
    
    const [clientsData, setClientsData] = useState({data: null, pageNumber: 1, pageSize: 10, filters:[]});
    useGetClientTableSchema(clientsData, setClientsData);

    const _columns = [
        {
            key: 'name',
            name: t('data-lang-lbl-name'),
            fieldName: 'name',
            minWidth: 150,
            maxWidth: 500,
            onRender:(item) => {
                return columnRender_Name(item, history, t('data-lang-pagename-listusers'))
            }
        },
        {  
            key: 'domain',
            name: t('data-lang-lbl-domain'),
            fieldName: 'domain',
            minWidth: 100,
            maxWidth: 500,
        },
        {  
            key: 'type',
            name: t('data-lang-lbl-type'),
            fieldName: 'type',
            minWidth: 100,
            maxWidth: 500,
        },
        {  
            key: 'locale',
            name: t('data-lang-lbl-locale'),
            fieldName: 'locale',
            minWidth: 100,
            maxWidth: 500,
        },
        {  
            key: 'id',
            name: t('data-lang-lbl-actions'),
            fieldName: 'id',
            minWidth: 170,
            maxWidth: 170,
            onRender:(item) => {
                return ColumnRender_Actions(item, contextSite.onlyObserver, history, {
                    manageproducts: t('data-lang-pagename-manageproducts'),
                    edituser: t('data-lang-pagename-edituser'),
                    profile: t('data-lang-pagename-profile')
                })
            }
        }
    ];

    return (
        <Row>
            <AuthVerify currentToken={currentAuth} />
            <Card  className="rounded-3">
                <Card.Title>
                    <h4 style={{borderBottom: "2px solid #b1b1b1"}}>{t('data-lang-pagename-listclients')}
                    </h4>
                </Card.Title>
                <Card.Body className="col-xs-12">
                    <Row>
                        <List setData={setClientsData} data={clientsData} columns={_columns} />
                    </Row>
                </Card.Body>
            </Card>
        </Row>
    ); 
}